<template>
    <ModalComponent v-if="showCloseModal">
      <div class="close-modal-body-wrapper">
        <p>{{ $t('closeChatModalMessage') }}</p>
        <div class="close-modal-buttons">
          <button @click="$emit('showModalClose')" class="button">
            {{ $t('cancel') }}
          </button>
          <button @click="$emit('endChat')" class="button button-primary">
            {{ $t('chatCloseButtonEndChat') }}
          </button>
        </div>
      </div>
    </ModalComponent>
        <ModalComponent v-if="showEndSessionModal">
      <div class="close-modal-body-wrapper">
        <h4 class="text-center"> {{ $t('sessionTermination') }}</h4>
      </div>
    </ModalComponent>
        <ModalComponent v-if="showAdditionalModal">
      <div class="additional-modal-body-wrapper">
        <div class="additional-modal-links">
          <a target="_blank" :href="privacyAnchorLink">
            <information :size="20" class="more-icon" />
            {{ $t('privacyLink') }}
          </a>
          <a target="_blank" :href="this.supportAnchorLinkFS">
            <information :size="20" class="material-icons more-icon" />
            {{ $t('support') }}
          </a>
        </div>
        <button @click="$emit('showAdditionalModalClose')" class="additional-modal-close-btn">
          {{ $t('cancel') }}
        </button>
      </div>
    </ModalComponent>
</template>

<script>
import ModalComponent from '@/components/common/ModalComponent.vue'
import Information from 'vue-material-design-icons/Information.vue'
import { useWidgetStore } from '@/store'
import { mapState } from 'pinia'

export default {
  name: 'ChatModals',
  components: {
    ModalComponent,
    Information
  },
  props: {
    showCloseModal: {
      type: Boolean,
      default: false
    },
    showEndSessionModal: {
      type: Boolean,
      default: false
    },
    showAdditionalModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      privacyAnchorLink: 'https://www.thermofisher.com/us/en/home/global/privacy-policy.html'
    }
  },
  computed: {
    ...mapState(useWidgetStore, [
      'supportAnchorLinkFS',
      'brandingColor'
    ])
  },
  emits: ['closeModal', 'endChat', 'closeAdditionalModal', 'showModalClose', 'showAdditionalModalClose'],
  methods: {
  },
  mounted () {
    if (window.location.hostname.includes('chemicals.thermofisher')) {
      this.privacyAnchorLink = 'https://chemicals.thermofisher.kr/content/chemicalssite/kr/en/home/support/privacy-policy.html'
      this.supportAnchorLink = 'https://chemicals.thermofisher.kr/content/chemicalssite/kr/en/home/support.html'
    }
  }
}
</script>

<style scoped>
.chat-container
  .close-modal-body-wrapper {
    padding: 20px 18px;

   p{
    text-align: center;
    line-height: 1rem;
    font-size: 14px;
    }
  h4{
    font-size: 14px;
    }
  h4.tfWarningText{
    color: #ed7700;
    }
 }
 .close-modal-buttons{
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  }
  .button,.button:hover {
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #FFFFFF;
    border: 1px solid #DCDCDC;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 700;
    color: #1E8AE7;
    padding: 0 20px;
    cursor: pointer;
   }
    .button-primary,.button-primary:hover {
        background-color: v-bind('brandingColor');
        color: #FFFFFF;
        border: none;
        }
  .additional-modal-body-wrapper{
    padding: 20px;

   .additional-modal-links{
    display: flex;
    flex-direction: column;
    align-items: center;
}
   a {
    text-decoration: none;
    display: flex;
    align-items: center;
    color: #1E8AE7 !important;
    font-weight: 500;
    font-size: 12px;
    margin-bottom: 10px;
  }
  span{
      margin-right: 5px;
      display: flex;
    }
  i {
    margin-right: 8px
  }
 .additional-modal-close-btn{
  border: 1px solid #E5E5E5;
  background-color: #fff;
  color: #54545C;
  border-radius: 3px;
  height: 32px;
  width: 100%;
  font-weight: 700;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
}
</style>
